export default {
  appName: "Zinzer",
  // apiUrl: "https://mapapun.com/Zinzer/api",
  apiUrl: "https://mapapun.com:3500",
  // apiKey: 'your-api-key',
};
